/* eslint-disable angular/document-service */

class FieldSenseListCtrl {
  constructor($scope) {
    'ngInject';
    this.filteredFields = [];
    $scope.$watch('$ctrl.elementText', eText => this.updateItems(eText || ''));
  }
  
  updateItems(eText) {
    let pattern = null;
    let filteredFields = [];
    let numWords = Math.min(eText.split(' ').length + 1, 5);
    let fields = angular.copy(this.fields);
    // try to (case-insensitive) match the last numWords typed words to a field name
    while (numWords-- && filteredFields.length < 5 && eText) {
      const filterText = eText.split(' ').splice(-1 * numWords).map(t => t.replace(/\W/g, '')).join(' ');
      if (!filterText) break; // do not try to match ''
      pattern = new RegExp(`(?<=.*)${filterText}`, 'i');
      const newFields = fields
        .filter(f => f.label.match(pattern))
        .map(f => ({filterText, ...f}));
      fields = fields.filter(f => !f.label.match(pattern))
      filteredFields = [...filteredFields, ...newFields];
    }

    this.filteredFields = filteredFields;
  }
  
  highlightField($event) {
    $('.field-sense-item.highlighted-field').removeClass('highlighted-field');
    $event && $($event.target).addClass('highlighted-field');
  }
}

export default {
  bindings: {
    fields: '<',
    elementText: '<',
    insertFieldSenseToken: '&'
  },
  templateUrl: "dynamic-builder/field-sense-list/field-sense-list.component.html",
  controller: FieldSenseListCtrl
};
